<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] flex flex-col">
    <div class="flex items-center justify-between mb-5 pb-4 border-b border-slate-100 dark:border-slate-800 gap-3">
      <div class="min-w-0">
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">devices</span>
          Session ที่กำลังใช้งาน
        </h3>
        <p class="text-sm text-slate-500 mt-1 font-medium truncate">
          {{ user.displayName || '—' }} · {{ user.login }}
        </p>
      </div>
      <div class="flex items-center gap-2 shrink-0">
        <button type="button" (click)="onRefresh()" [disabled]="isLoading() || isKicking()"
          class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-amber-500 hover:bg-amber-50 transition-colors border-none bg-transparent cursor-pointer disabled:opacity-40">
          <span class="material-icons">refresh</span>
        </button>
        <button type="button" (click)="onClose()"
          class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors border-none bg-transparent cursor-pointer">
          <span class="material-icons">close</span>
        </button>
      </div>
    </div>

    <div class="flex items-center justify-between gap-3 mb-4">
      <p class="text-xs text-slate-500 font-medium">
        {{ sessions().length }} เครื่องที่ยังค้างอยู่
      </p>
      <button *ngIf="canKick" type="button" (click)="askKickAll()"
        [disabled]="sessions().length === 0 || isKicking()"
        class="px-4 py-2.5 bg-rose-500 hover:bg-rose-600 text-white font-bold rounded-xl cursor-pointer border-none disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1.5">
        <span class="material-icons text-[18px]">logout</span>
        เตะทุกเครื่อง
      </button>
    </div>

    <div class="overflow-x-auto custom-scrollbar flex-1 min-h-[240px] relative rounded-2xl border border-slate-100 dark:border-slate-800">
      <div *ngIf="isLoading() || isKicking()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 z-10 flex items-center justify-center">
        <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <table class="w-full text-left border-collapse">
        <thead class="bg-slate-50 dark:bg-slate-800/80">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-3">เข้าสู่ระบบเมื่อ</th>
            <th class="p-3">IP</th>
            <th class="p-3">อุปกรณ์ / Browser</th>
            <th *ngIf="canKick" class="p-3 text-center w-[100px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let s of sessions()" class="text-sm">
            <td class="p-3 text-xs text-slate-500 whitespace-nowrap">
              {{ s.loginAt | date:'dd/MM/yyyy HH:mm:ss' }}
            </td>
            <td class="p-3 font-mono text-xs text-slate-500">{{ s.ipAddress || '—' }}</td>
            <td class="p-3 text-slate-600 dark:text-slate-300">
              <p class="text-[11px] text-slate-500 break-all max-w-md">{{ s.userAgent || '—' }}</p>
            </td>
            <td *ngIf="canKick" class="p-3 text-center">
              <button type="button" (click)="askKickOne(s.id)" [disabled]="isKicking()"
                class="px-3 py-1.5 rounded-lg text-xs font-bold text-rose-600 bg-rose-50 hover:bg-rose-100 border-none cursor-pointer disabled:opacity-40">
                เตะออก
              </button>
            </td>
          </tr>
          <tr *ngIf="sessions().length === 0 && !isLoading()">
            <td [attr.colspan]="canKick ? 4 : 3" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">devices_off</span>
              <p class="font-bold">ไม่มีเครื่องที่ค้างอยู่</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex items-center justify-end mt-4 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button type="button" (click)="onClose()"
        class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 font-bold rounded-xl cursor-pointer border-none">
        ปิด
      </button>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="pendingKickSessionId !== null"
  title="ยืนยันการเตะเครื่อง?"
  message="ต้องการบังคับออกจากระบบเครื่องนี้"
  messageSuffix="หรือไม่?"
  confirmLabel="เตะออก"
  variant="warning"
  icon="logout"
  [showIrreversibleNote]="false"
  [loading]="isKicking()"
  (confirm)="confirmKickOne()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-pss-confirm-modal *ngIf="isConfirmKickAllOpen"
  title="ยืนยันการเตะทุกเครื่อง?"
  message="จะบังคับออกจากระบบทุกเครื่องของ"
  [highlight]="user.login"
  messageSuffix="ทันที"
  confirmLabel="เตะทุกเครื่อง"
  variant="danger"
  icon="devices"
  [showIrreversibleNote]="false"
  [loading]="isKicking()"
  (confirm)="confirmKickAll()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>
